
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction-hold-feedback",
      function () {
        return require("private-next-pages/transaction-hold-feedback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction-hold-feedback"])
      });
    }
  